module.exports = __webpack_public_path__ + "img/roammingMobile.ff326c6d.png";